import React, { useContext } from 'react';
import dayjs from 'dayjs';
import tz from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
dayjs.extend(tz);

import { CatalogContext } from 'src/pages/CatalogPage/CatalogPage';
import { IAuctionItem } from 'src/pages/CatalogPage/CatalogPage.i';
import { Tag, Typography } from '@riac/design-system';
import { interestLevels } from 'src/lib/interestLevels';

import { LazyImg } from '@riac/design-system';
import LogoYoutube from 'images/logo-youtube.png';

export const ItemIcons = ({ item }: { item: IAuctionItem }) => {
  const { auctionEndDate } = useContext(CatalogContext);

  const hideInterestLevel = dayjs().tz('America/Chicago').isAfter(auctionEndDate.add(1, 'day'));
  const itemInterest = item.ItemInterest > 3 ? 3 : item.ItemInterest;
  const tests = [/A/, /I/, /M/, /C/];

  return (
    <div className='flex flex-row flex-wrap gap-2 items-center justify-between'>
      <div className='flex flex-row flex-wrap gap-2 items-center'>
        {/*
            item.LotItemCount > 1 &&
            <WithTooltip position='top' text={`Lot contains ${item.LotItemCount} items`} inverted>
            <LazyImg
              className="LazyImg-responsive LazyImg-fluid icon"
              src={broken('images/icon-unreadsystem.jpg'))}
              alt={`Lot contains ${item.LotItemCount} items`}
            />
            </WithTooltip>
          */}

        {/* item.RareItem && (
          <WithTooltip position='top' text='Lot contains rare items' inverted>
            <LazyImg src={LogoRare} alt='Lot contains rare items' />
          </WithTooltip>
        )*/}
        {item.HasDocs && (
          <Tag label='Documentation'/>
        )}
        {item.HasBox && (
          <Tag label='Has Box'/>
        )}
        {tests[0].test(item.A_MCodeLot || item.A_MCode) && (
          <Tag label='Antique'/>
        )}
        {tests[1].test(item.A_MCodeLot || item.A_MCode) && (
          <Tag label='Class III'/>
        )}
        {tests[2].test(item.A_MCodeLot || item.A_MCode) && (
          <Tag label='Modern'/>
        )}
        {tests[3].test(item.A_MCodeLot || item.A_MCode) && (
          <Tag label='Curio and Relic'/>
        )}
        {item.HasVideo && (
          <LazyImg
            src={LogoYoutube}
            alt='Lot contains items with attached video'
            className='w-6 h-6'
          />
        )}
      </div>
      {!hideInterestLevel && item.ItemInterest !== 0 && (
        <div className='flex flex-row gap-2 items-center'>
          <Typography color='text-light' className='text-base leading-6'>Interest: </Typography>
          <svg width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="8" width="12" height="8" rx="1" fill="#22C55E"/>
            <rect x="14" y="4" width="12" height="12" rx="1" fill={item.ItemInterest >= 2 ? '#22C55E' : "#D4D4D4"}/>
            <rect x="28" width="12" height="16" rx="1" fill={item.ItemInterest >= 3 ? '#22C55E' : "#D4D4D4"}/>
          </svg>
        </div>
      )}
    </div>
  );
};
